<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">

      <!-- Top-level enabled toggle -->
      <div class="d-flex align-items-center mb-3 alerts-global-row">
        <span class="alerts-global-label" style="min-width: auto; margin-right: 12px">Enabled</span>
        <b-form-select v-model="model.data_services_enabled" :options="boolean_options" style="width:100px"></b-form-select>
      </div>

      <!-- Smart Dispatching (admin only) -->
      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isSmartDispatchingVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isSmartDispatchingVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isSmartDispatchingVisible }">&#9654;</span>
          <span class="alert-section-title">Smart Dispatching Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.smart_dispatching_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isSmartDispatchingVisible" :visible="!!toggle.isSmartDispatchingVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="smart_dispatching_vehicle_types">
                <td class="alert-label">Supported Vehicle Types</td>
                <td><b-form-textarea v-model="model.smart_dispatching_vehicle_types" type="text" style="field-sizing: content"></b-form-textarea></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isRoutingVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isRoutingVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isRoutingVisible }">&#9654;</span>
          <span class="alert-section-title">Telematics Route Sync Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.routes_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isRoutingVisible" :visible="!!toggle.isRoutingVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr v-if="telematics_type=='SAMSARA'">
                <td class="alert-label">Routes - Assign To Drivers</td>
                <td><b-form-select v-model="model.routes_assign_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="telematics_type=='SAMSARA'">
                <td class="alert-label">Routes - Assign To Drivers Then Vehicles</td>
                <td><b-form-select v-model="model.routes_assign_to_driver_then_vehicle" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="telematics_type=='SAMSARA' && tenant_type=='TBN'">
                <td class="alert-label">Route - Assign Vehicles To Existing Routes</td>
                <td><b-form-select v-model="model.routes_vehicle_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type=='TBN' && telematics_type=='SAUCON'">
                <td class="alert-label">Route - Assign To Existing Saucon Routes</td>
                <td><b-form-select v-model="model.routes_saucon_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type=='TBN'">
                <td class="alert-label">Route - Assign To Existing Routes Filter</td>
                <td><b-form-input v-model="model.routes_vehicle_assignments_filter" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>
      
      
      <!-- Tyler Route Sync (TBN only) -->
      <b-card v-if="tenant_type === 'TBN'" no-body class="alert-section-card mb-2" data-section="isTylerSyncVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isTylerSyncVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isTylerSyncVisible }">&#9654;</span>
          <span class="alert-section-title">Tyler Route Sync Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.tbn_tyler_route_sync_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isTylerSyncVisible" :visible="!!toggle.isTylerSyncVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="tbn_tyler_route_sync_mapping">
                <td class="alert-label">Tyler → TBN Route Mapping</td>
                <td>
                  <JsonObjectListEditor v-model="model.tbn_tyler_route_sync_mapping" fieldKey="tbn_tyler_route_sync_mapping" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="tyler_route_sync_mapping_columns"/>
                  <b-form-invalid-feedback :state="jsonState('tbn_tyler_route_sync_mapping')">{{ jsonFeedback('tbn_tyler_route_sync_mapping') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="tbn_tyler_route_sync_keys">
                <td class="alert-label">Tyler Route Sync Keys</td>
                <td>
                  <!-- fullstory: fs-exclude so tyler api keys are never captured -->
                  <JsonObjectListEditor v-model="model.tbn_tyler_route_sync_keys" fieldKey="tbn_tyler_route_sync_keys" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="tyler_route_sync_keys_columns" class="fs-exclude"/>
                  <b-form-invalid-feedback :state="jsonState('tbn_tyler_route_sync_keys')">{{ jsonFeedback('tbn_tyler_route_sync_keys') }}</b-form-invalid-feedback>
                </td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Sync Drivers -->
      <b-card no-body class="alert-section-card mb-2" data-section="isSyncDriversVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isSyncDriversVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isSyncDriversVisible }">&#9654;</span>
          <span class="alert-section-title">Sync Drivers Enabled</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.data_services_compare_drivers_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isSyncDriversVisible" :visible="!!toggle.isSyncDriversVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="avatar_api_url">
                <td class="alert-label">Avatar API URL</td>
                <td><b-form-input v-model="model.avatar_api_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="avatar_api_token">
                <td class="alert-label">Avatar API Token</td>
                <td><b-form-input v-model="model.avatar_api_token" type="text" class="fs-exclude"></b-form-input></td>
              </tr>
              <tr data-field="data_services_compare_drivers_add_enabled">
                <td class="alert-label">Compare Drivers Add Enabled</td>
                <td><b-form-select v-model="model.data_services_compare_drivers_add_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_job_filters">
                <td class="alert-label">Avatar Job Filters</td>
                <td>
                  <!-- Backend (tbn_compare_drivers.py) excludes any Avatar driver whose
                       job name contains one of these tokens; there's no `*`/`-` wildcard
                       support, so this is a plain exclusion list (variant="list"), not
                       the allow/exclude toggle used elsewhere. -->
                  <FilterSettingEditor
                    v-model="model.data_services_compare_drivers_avatar_job_filters"
                    fieldKey="data_services_compare_drivers_avatar_job_filters"
                    variant="list"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_status_filters">
                <td class="alert-label">Avatar Statuses To Exclude</td>
                <td>
                  <!-- Same plain-exclusion-list backend behavior as the job filter above. -->
                  <FilterSettingEditor
                    v-model="model.data_services_compare_drivers_avatar_status_filters"
                    fieldKey="data_services_compare_drivers_avatar_status_filters"
                    variant="list"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_driver_name_filter">
                <td class="alert-label">Avatar Driver Name Filters</td>
                <td>
                  <!-- Pre-existing backend bug (tbn_compare_drivers.py ~166-168): only this
                       field's truthiness is checked, but tbn_driver_name_filter's *value*
                       is what actually gets used for the comparison. Not introduced by this
                       migration and not fixed here (no backend changes in this pass) — flagging
                       so nobody assumes this field's content does anything on its own. -->
                  <FilterSettingEditor
                    v-model="model.data_services_compare_drivers_avatar_driver_name_filter"
                    fieldKey="data_services_compare_drivers_avatar_driver_name_filter"
                    variant="list"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_tbn_status_map">
                <td class="alert-label">Avatar To TBN Status Mapping</td>
                <td>
                  <JsonKeyValueEditor v-model="model.data_services_compare_drivers_avatar_tbn_status_map" fieldKey="data_services_compare_drivers_avatar_tbn_status_map" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Avatar Status" valueLabel="TBN Status"/>
                  <b-form-invalid-feedback :state="jsonState('data_services_compare_drivers_avatar_tbn_status_map')">{{ jsonFeedback('data_services_compare_drivers_avatar_tbn_status_map') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_avatar_samsara_status_map">
                <td class="alert-label">Avatar To Samsara Tags Mapping</td>
                <td>
                  <JsonKeyValueEditor v-model="model.data_services_compare_drivers_avatar_samsara_status_map" fieldKey="data_services_compare_drivers_avatar_samsara_status_map" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Avatar Status" valueLabel="Samsara Tag"/>
                  <b-form-invalid-feedback :state="jsonState('data_services_compare_drivers_avatar_samsara_status_map')">{{ jsonFeedback('data_services_compare_drivers_avatar_samsara_status_map') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_tbn_location_filters">
                <td class="alert-label">TBN Location Filters</td>
                <td>
                  <!-- Backend excludes any TBN driver whose primaryLocation contains one of
                       these tokens (comma-split, substring match) — plain exclusion list,
                       no `*`/`-` wildcard support. -->
                  <FilterSettingEditor
                    v-model="model.data_services_compare_drivers_tbn_location_filters"
                    fieldKey="data_services_compare_drivers_tbn_location_filters"
                    variant="list"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_tbn_driver_name_filter">
                <td class="alert-label">TBN Driver Name Filters</td>
                <td>
                  <!-- Backend does a whole-string substring check (driver name found
                       anywhere within this field's raw value), not a comma-split list —
                       same shape as driver_trip_notifications_skip_routes. Using variant="list"
                       for a friendlier chip UI; multiple chips are comma-joined same as before. -->
                  <FilterSettingEditor
                    v-model="model.data_services_compare_drivers_tbn_driver_name_filter"
                    fieldKey="data_services_compare_drivers_tbn_driver_name_filter"
                    variant="list"
                    :allow-raw-edit="isEffectiveAdmin"
                    @validation="onFilterValidation"
                  />
                </td>
              </tr>
              <tr data-field="data_services_compare_drivers_auto_sync_profiles_nightly_enabled">
                <td class="alert-label">Auto Sync Profiles Nightly</td>
                <td><b-form-select v-model="model.data_services_compare_drivers_auto_sync_profiles_nightly_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="data_services_compare_drivers_auto_sync_profiles_nightly_email_recipients">
                <td class="alert-label">Auto Sync Profiles Nightly Email Recipients</td>
                <td><b-form-input v-model="model.data_services_compare_drivers_auto_sync_profiles_nightly_email_recipients" type="text" placeholder="email1@example.com,email2@example.com"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Driver Manager (TBN) -->
      <b-card v-if="tenant_type !== 'CM'" no-body class="alert-section-card mb-2" data-section="isScorecardVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isScorecardVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isScorecardVisible }">&#9654;</span>
          <span class="alert-section-title">Driver Manager</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.driver_scorecard_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isScorecardVisible" :visible="!!toggle.isScorecardVisible">
          <b-card-body>
            <!-- weights + conditional coloring moved to the settings modal on the
                 Driver Manager dashboard itself (FI-2047); only the enable flag lives here -->
            <p class="text-muted mb-1" style="font-size: 13px;">
              Combined Score Weights and Conditional Coloring now live on the Driver Manager Dashboard.
              <router-link :to="{ name: 'driver_manager_dashboard', query: { settings: '1' } }">Open Driver Manager settings</router-link>
            </p>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Driver Manager (CM) -->
      <b-card v-if="tenant_type === 'CM'" no-body class="alert-section-card mb-2" data-section="isCmScorecardVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isCmScorecardVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isCmScorecardVisible }">&#9654;</span>
          <span class="alert-section-title">Driver Manager (CM)</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.cm_driver_scorecard_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isCmScorecardVisible" :visible="!!toggle.isCmScorecardVisible">
          <b-card-body>
            <p class="text-muted mb-1" style="font-size: 13px;">
              Combined Score Weights and Conditional Coloring now live on the Driver Manager Dashboard.
              <router-link :to="{ name: 'driver_manager_dashboard', query: { settings: '1' } }">Open Driver Manager settings</router-link>
            </p>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Advanced (admin only) -->
      <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-2" data-section="isAdvVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isAdvVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isAdvVisible }">&#9654;</span>
          <span class="alert-section-title">Advanced</span>
        </b-card-header>
        <b-collapse id="collapse-isAdvVisible" :visible="!!toggle.isAdvVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="booking_customer_portal_enabled">
                <td class="alert-label">Booking Customer Portal Enabled</td>
                <td><b-form-select v-model="model.booking_customer_portal_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <div class="tc-sticky-save">
      <transition name="tc-save-slide">
      <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
        <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
        <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
        &nbsp;&nbsp;
        <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
      </div>
      </transition>
    </div>
  </div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import {mapState} from "vuex";
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import JsonKeyValueEditor from './JsonKeyValueEditor.vue'
import JsonObjectListEditor from './JsonObjectListEditor.vue'
import FilterSettingEditor from './FilterSettingEditor.vue'
import { ensureFilterKeys } from '../utils/filter_syntax'

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, jsonValidationMixin, dirtyTrackingMixin],
  components: {
    JsonKeyValueEditor,
    JsonObjectListEditor,
    FilterSettingEditor,
  },

  data() {
    return {
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {
        isSmartDispatchingVisible: false,
        isTylerSyncVisible: false,
        isSyncDriversVisible: false,
        isScorecardVisible: false,
        isAdvVisible: false,
      },
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      tyler_route_sync_mapping_columns: [
        { key: 'contractName', label: 'TBN Contract Name', placeholder: 'e.g. Bloomfield BOE (2025-26)' },
        { key: 'tylerPath', label: 'Tyler Path', placeholder: 'e.g. CTDATTCOPlainvilleSD' },
        { key: 'effectiveStartDate', label: 'Effective Start Date', type: 'date' },
        { key: 'effectiveEndDate', label: 'Effective End Date', type: 'date' },
      ],
      tyler_route_sync_keys_columns: [
        { key: 'contractName', label: 'TBN Contract Name', placeholder: 'e.g. Bloomfield BOE (2025-26)' },
        { key: 'apiKey', label: 'API Key', placeholder: 'Tyler API key' },
        { key: 'effectiveStartDate', label: 'Effective Start Date', type: 'date' },
        { key: 'effectiveEndDate', label: 'Effective End Date', type: 'date' },
      ],
      fieldPrefixSectionMap: [
        ['smart_dispatching_', 'isSmartDispatchingVisible'],
        ['tbn_tyler_', 'isTylerSyncVisible'],
        ['data_services_compare_drivers_', 'isSyncDriversVisible'],
        ['avatar_', 'isSyncDriversVisible'],
        ['driver_scorecard_', 'isScorecardVisible'],
        ['booking_customer_portal_', 'isAdvVisible'],
      ],
      jsonFieldToggleMap: {
        tbn_tyler_route_sync_mapping: 'isTylerSyncVisible',
        tbn_tyler_route_sync_keys: 'isTylerSyncVisible',
        tbn_tyler_contract_driver_time_offsets: 'isTylerSyncVisible',
        data_services_compare_drivers_avatar_tbn_status_map: 'isSyncDriversVisible',
        data_services_compare_drivers_avatar_samsara_status_map: 'isSyncDriversVisible',
      },
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        ensureFilterKeys(this.model, [
          'data_services_compare_drivers_avatar_job_filters',
          'data_services_compare_drivers_avatar_status_filters',
          'data_services_compare_drivers_avatar_driver_name_filter',
          'data_services_compare_drivers_tbn_location_filters',
          'data_services_compare_drivers_tbn_driver_name_filter',
        ])

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
          // always treat these as JSON fields even when not yet set in DDB
          if (!this.objectKeyList.includes('tbn_tyler_route_sync_mapping')) {
            this.objectKeyList.push('tbn_tyler_route_sync_mapping')
          }
          this.model.tbn_tyler_route_sync_mapping = this.migrateTylerRouteSyncMapping(this.model.tbn_tyler_route_sync_mapping)
        } catch(e) {
          console.log('error looping through keys',e)
        }

        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
      this.saving = false
    },
    async save_config() {
      try {
        this.saving = true
        this.flushFilterValidation()
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }
        await update_tenant_config_settings(this.user.tenant, payload)
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item, field, setting) {
      if (item[field] !== setting) {
        this.$set(item, field, setting)
      }
    },
    toggle_div(item, field) {
      this.$set(item, field, !item[field])
    },
    migrateTylerRouteSyncMapping(value) {
      if (value == null || value === '') {
        return ''
      }
      if (Array.isArray(value)) {
        return JSON.stringify(value)
      }
      if (typeof value !== 'string') {
        return ''
      }
      const trimmed = value.trim()
      if (!trimmed) {
        return ''
      }
      if (trimmed.startsWith('[')) {
        return value
      }
      const entries = trimmed.split(',').map(part => {
        const segments = part.trim().split(':')
        if (segments.length < 2) {
          return null
        }
        return {
          contractName: segments[0].replace(/\n/g, '').trim(),
          tylerPath: segments.slice(1).join(':').replace(/\n/g, '').trim(),
        }
      }).filter(entry => entry && entry.contractName && entry.tylerPath)
      return entries.length ? JSON.stringify(entries) : ''
    },
    isPlainObject(value,key) {
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";

</style>
